import { FormItemsGroup, Input, Space, Spacing, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useCompanyInformationForm } from '../../../../contexts/companyInformationFormContext'

export const CompanyAddress = (): ReactElement => {
  const { t } = useTranslation()
  const { companyInformationForm } = useCompanyInformationForm()
  const { FormItem } = companyInformationForm

  return (
    <>
      <Space size="s24" />
      <Text variant="h4">{t('external_invoices.company_information_modal.address')}</Text>
      <Space size="s16" />
      <FormItem
        name="companyAddress"
        label={t('external_invoices.company_information_modal.company_address')}
        render={({ field }) => <Input {...field} />}
      />
      <Space size="s16" />
      <FormItem
        name="addressLine2"
        label={t('external_invoices.company_information_modal.company_addressLine2.label')}
        render={({ field }) => (
          <Input
            {...field}
            placeholder={t('external_invoices.company_information_modal.company_addressLine2.placeholder')}
          />
        )}
      />
      <Space size="s16" />
      <FormItemsGroup itemsTemplate={['25%', '75%']} rowSpacing={Spacing.S16}>
        <FormItem
          name="companyZipCode"
          label={t('external_invoices.company_information_modal.company_zipCode')}
          render={({ field }) => <Input {...field} />}
        />
        <FormItem
          name="companyCity"
          label={t('external_invoices.company_information_modal.company_city')}
          render={({ field }) => <Input {...field} />}
        />
      </FormItemsGroup>
    </>
  )
}
